module.exports = __webpack_public_path__ + "img/mobile/BetBar/btn-sound_off@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/btn-sound_off@1x.png
// module id = 602
// module chunks = 0